import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import Swiper, { Navigation } from 'swiper';





	const swiper = new Swiper('.swiper-events', {        
        modules: [Navigation],
		loop: false,
		centeredSlides: true,
		slidesPerView: 1.3,
		spaceBetween: 30,
		breakpoints: {
			768: {
				loop: false,
				centeredSlides: false,
				grabCursor: true,
				slidesPerView: 2.3,
				spaceBetween: 30,
			},
			1200: {
				loop: false,
				centeredSlides: false,
				grabCursor: true,
				slidesPerView: 2,
				spaceBetween: 60,
			},
			1600: {
				loop: false,
				centeredSlides: false,
				grabCursor: true,
				slidesPerView: 3,
				spaceBetween: 60,
			},
		},
		navigation: {
			nextEl: '.in-button-next',
			prevEl: '.in-button-prev'
		}
	});












